{
  "(optional)": "(neobligāti)",
  "(required)": "(obligāti)"
}
